var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSystemMasterdataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#C6D5DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 7.33333H11.6094L10.4714 6.19533C10.4096 6.13331 10.3361 6.08411 10.2552 6.05059C10.1743 6.01707 10.0876 5.99987 10 6H6.66671C5.93137 6 5.33337 6.598 5.33337 7.33333V16.6667C5.33337 17.402 5.93137 18 6.66671 18H17.3334C18.0687 18 18.6667 17.402 18.6667 16.6667V8.66667C18.6667 7.93133 18.0687 7.33333 17.3334 7.33333ZM6.66671 16.6667V8.66667H17.3334L17.3347 16.6667H6.66671Z",
    fill: "#171A1C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemMasterdataIcon);
export default __webpack_public_path__ + "static/media/systemMasterdataIcon.cd8a063c6ace7f451689de43c7c7d7fd.svg";
export { ForwardRef as ReactComponent };